import btlBanner from './img/btl.png'
import btlPrincipal from './img/btl_principal.jpg'
import btlContact from './img/btl_banner.png'
import btlG1 from './img/btl/g1.jpg'
import btlG2 from './img/btl/g2.jpg'
import btlG3 from './img/btl/g3.jpg'
import btlG4 from './img/btl/g4.jpg'
import btlG5 from './img/btl/g5.jpg'
import btlG6 from './img/btl/g6.jpg'
import btlG7 from './img/btl/g7.jpg'
import btlG8 from './img/btl/g8.jpg'
import btlG9 from './img/btl/g9.jpg'

import oohBanner from './img/ooh.png'
import oohPrincipal from './img/ooh_principal.jpg'
import oohContact from './img/ooh_banner.png'
import oohG1 from './img/ooh/g1.jpg'
import oohG2 from './img/ooh/g2.jpg'
import oohG3 from './img/ooh/g3.jpg'
import oohG4 from './img/ooh/g4.jpg'
import oohG5 from './img/ooh/g5.jpg'
import oohG6 from './img/ooh/g6.jpg'
import oohG7 from './img/ooh/g7.jpg'
import oohG8 from './img/ooh/g8.jpg'
import oohG9 from './img/ooh/g9.jpg'

import printBanner from './img/print.png'
import printPrincipal from './img/print_principal.jpg'
import printContact from './img/print_banner.png'
import printG1 from './img/print/g1.jpg'
import printG2 from './img/print/g2.jpg'
import printG3 from './img/print/g3.jpg'
import printG4 from './img/print/g4.jpg'
import printG5 from './img/print/g5.jpg'
import printG6 from './img/print/g6.jpg'
import printG7 from './img/print/g7.jpg'
import printG8 from './img/print/g8.jpg'
import printG9 from './img/print/g9.jpg'

import arquitecturaBanner from './img/arquitectura.png'
import arquitecturaPrincipal from './img/arquitectura_principal.jpg'
import arquitecturaContact from './img/arquitectura_banner.png'
import arquitecturaG1 from './img/arquitectura/g1.jpg'
import arquitecturaG2 from './img/arquitectura/g2.jpg'
import arquitecturaG3 from './img/arquitectura/g3.jpg'
import arquitecturaG4 from './img/arquitectura/g4.jpg'
import arquitecturaG5 from './img/arquitectura/g5.jpg'
import arquitecturaG6 from './img/arquitectura/g6.jpg'
import arquitecturaG7 from './img/arquitectura/g7.jpg'
import arquitecturaG8 from './img/arquitectura/g8.jpg'
import arquitecturaG9 from './img/arquitectura/g9.jpg'

import experienceBanner from './img/experience.png'
import experiencePrincipal from './img/experience_principal.jpg'
import experienceContact from './img/experience_banner.png'
import experienceG1 from './img/experience/g1.jpg'
import experienceG2 from './img/experience/g2.jpg'
import experienceG3 from './img/experience/g3.jpg'
import experienceG4 from './img/experience/g4.jpg'
import experienceG5 from './img/experience/g5.jpg'
import experienceG6 from './img/experience/g6.jpg'
import experienceG7 from './img/experience/g7.jpg'
import experienceG8 from './img/experience/g8.jpg'
import experienceG9 from './img/experience/g9.jpg'

import mediosBanner from './img/medios.png'
import mediosPrincipal from './img/medios_principal.jpg'
import mediosContact from './img/medios_banner.png'
import mediosG1 from './img/medios/g1.jpg'
import mediosG2 from './img/medios/g2.jpg'
import mediosG3 from './img/medios/g3.jpg'
import mediosG4 from './img/medios/g4.jpg'
import mediosG5 from './img/medios/g5.jpg'
import mediosG6 from './img/medios/g6.jpg'
import mediosG7 from './img/medios/g7.jpg'
import mediosG8 from './img/medios/g8.jpg'
import mediosG9 from './img/medios/g9.jpg'

export const services = [
  {
    id: 'btl',
    img: btlBanner,
    imgDesc: btlPrincipal,
    imgContact: btlContact,
    title: 'Conectamos marcas con personas, creando experiencias que dejan huella.',
    desc: 'En MG Publicidad desarrollamos estrategias BTL (Below The Line) que van más allá de la publicidad tradicional. Creamos experiencias directas, memorables y emocionalmente significativas entre las marcas y sus consumidores. Diseñamos, producimos y ejecutamos activaciones creativas en punto de venta, eventos, espacios públicos y escenarios no convencionales, generando interacción real, impacto inmediato y recordación de marca.',
    serv: [
        'Punto de venta',
        'Animación',
        'Street marketing',
        'Distribución publicitaria casa por casa ',
        'Valla móvil, valla experiencia, valla experiencia, vallas LED e implementaciones especiales',
        'Publiandantes, publiandantes LED',
        'Rolling semáforo',
        'Activaciones en cine',
        'Dron show',
        'Sampling',
        'Bicivalla',
        'Motovalla' ],
    servTitle: 'SERVICIOS',
    staff: [
        'STAFF',
        'Animadores',
        'Modelos',
        'Edecanes',
        'Promotores',
        'Productor de eventos',
        'Gestores',
        'Mistery shopper',
    ],
    footerSub: null,
    footerTitle: null,
    staffTitle: 'STAFF',
    color: '#9A997E',
    colorSec: '#ADAC91',
    gallery : [ btlG1, btlG2, btlG3, btlG4, btlG5, btlG6, btlG7, btlG8, btlG9 ]
  },
  {
    id: 'ooh',
    img: oohBanner,
    imgDesc: oohPrincipal,
    imgContact: oohContact,
    title: '',
    desc: 'Llega a una gran audiencia de manera efectiva a través de canales tradicionales publicitarios. Consigue impacto inmediato y masivo.',
    servTitle: 'SERVICIOS',
    serv: [
      'Espectaculares',
      'Vallas ﬁjas y digitales',
      'Bajopuente y cabeceras',
      'Pintamuros',
      'Camiones urbanos',
      'Metro',
      'Metrobús',
      'Mexibús'],
    staff: [
      'Tren ligero',
      'Suburbano',
      'Parabuses',
      'Sitios de taxi',
      'Dirigibles',
      'Aerostáticos',
      'Skybanner',
      'Vía verde',
    ],
    footerSub: null,
    footerTitle: null,
    staffTitle: '',
    color: '#243A31',
    colorSec: '#50615A',
    gallery : [ oohG1, oohG2, oohG3, oohG4, oohG5, oohG6, oohG7, oohG8, oohG9 ]
  },
  {
    id: 'print',
    img: printBanner,
    imgDesc: printPrincipal,
    imgContact: printContact,
    title: 'Calidad que se ve. Impacto que se siente.',
    desc: 'En MG Print convertimos tus ideas en piezas tangibles de alta calidad. Somos especialistas en soluciones de impresión y producción gráfica que refuerzan la identidad de tu marca y elevan tu presencia en cualquier espacio.Desde el diseño hasta la instalación, gestionamos todo el proceso con precisión, creatividad y eficiencia. Contamos con tecnología de punta, materiales de primer nivel y un equipo comprometido con la excelencia en cada detalle.',
    servTitle: 'SERVICIOS',
    serv: [
      'Impresión Offset',
      'Impresión digital y gran formato',
      'Impresión en promocionales',
      'Serigrafía',
      'DTF'
    ],
    staff: [
      'Bordado',
      'Sublimación',
      'Transferencia de calor',
      'Señalización',
      'Retiro e instalación de materiales impresos'
    ],
    footerSub: null,
    footerTitle: null,
    staffTitle: '',
    color: '#D77160',
    colorSec: '#D58080',
    gallery : [ printG1, printG2, printG3, printG4, printG5, printG6, printG7, printG8, printG9 ]
  },
  {
    id: 'arquitectura',
    img: arquitecturaBanner,
    imgDesc: arquitecturaPrincipal,
    imgContact: arquitecturaContact,
    title: 'Diseño que impacta, estructuras que comunican.',
    desc: 'En nuestro taller nos especializamos en crear espacios físicos y estructuras visuales que transforman una marca en una experiencia tangible e inolvidable. Diseñamos y producimos soluciones a la medida que no solo llaman la atención, sino que comunican de forma estratégica el mensaje de tu marca',
    servTitle: 'SERVICIOS',
    serv: [
      'Stands personalizados para expos y ferias',
      'Mobiliaro',
      'POP up Store',
      'Islas y kioscos comerciales',
      'Showrooms y activaciones',
      'Displays y estructuras modulares'
    ],
    staff: [
      'Rotulación y señalética personalizada',
      'Volumetricos',
      'Exhibidores',
      'Desarrollos de proyectos especiales',
      'Photo Oportunities',
      'Conceptualización y renders'
    ],
    footerSub: 'Presencia en mas de',
    footerTitle: '25 expos al año',
    staffTitle: '',
    color: '#4A6E7B',
    colorSec: '#6E8089',
    gallery : [ arquitecturaG1, arquitecturaG2, arquitecturaG3, arquitecturaG4, arquitecturaG5, arquitecturaG6, arquitecturaG7, arquitecturaG8, arquitecturaG9 ]
  },
  {
    id: 'experience',
    img: experienceBanner,
    imgDesc: experiencePrincipal,
    imgContact: experienceContact,
    title: '',
    desc: 'Creamos experiencias que transforman al consumidor en protagonista. Diseñamos, producimos y ejecutamos activaciones de marca, eventos, experiencias inmersivas y estrategias sensoriales que generan conexiones reales y duraderas.',
    servTitle: '',
    serv: [
      'Experiencias inmersivas (realidad aumentada, VR, etc.)',
      'Marketing sensorial (olfativo, táctil, auditivo)',
      'Roadshows y promociones en punto de venta',
      'Pop-up experiences',
      'Maping',
      'Brand experience strategy'
    ],
    staff: [
    ],
    footerSub: null,
    footerTitle: null,
    staffTitle: '',
    color: '#4B90BA',
    colorSec: '#6DAAC9',
    gallery : [ experienceG1, experienceG2, experienceG3, experienceG4, experienceG5, experienceG6, experienceG7, experienceG8, experienceG9 ]
  },
  {
    id: 'medios',
    img: mediosBanner,
    imgDesc: mediosPrincipal,
    imgContact: mediosContact,
    title: '',
    desc: 'Conseguimos que tu marca sea recordada y vista por millones de manera efectiva a través de canales novedosos, de calidad y con un alto impacto.',
    servTitle: '',
    serv: [
      'BBVA TV',
      'Cinemex y Cinépolis',
      'Centros comerciales',
      'Aeropuertos',
      'Restaurantes "La Casa de Toño"'
    ],
    staff: [
      'Jets privados',
      'Campos de golf',
      'Banners de led en restaurantes',
      'Radio regional',
      'Azteca Media'
    ],
    footerSub: null,
    footerTitle: null,
    staffTitle: '',
    color: '#80D2AE',
    colorSec: '#91E2BF',
    gallery : [ mediosG1, mediosG2, mediosG3, mediosG4, mediosG5, mediosG6, mediosG7, mediosG8, mediosG9 ]
  }
]